import type { StatusLoyalty } from '@/types/Loyalty';

import type {
  AgentPrivilege,
  AgentResponse,
  LoyaltyLevelStatus,
  LoyaltyPrivilege,
} from './types';

export const EMPTY_AGENT_INFO: AgentResponse = {
  agent: {
    fullName: '-',
    email: '-',
    phone: '-',
    pointsAwarded: '-',
    pointsDeducted: '-',
    point: '-',
    starsCount: 0,
    acceptOffer: null,
    privileges: [],
  },
  status: {
    label: '-',
    icon: null, // иконка
    background: {}, // подложка
    nextAmount: '-', // до следующего статуса
    date: '-', // дата получения статуса
    date_downgrade_status: '', // дата понижения статуса
  },
};

export function mapLoyaltyLevelStatus (status: StatusLoyalty | undefined): LoyaltyLevelStatus {
  const {
    icon,
    label,
    background,
    nextAmount,
  } = status ?? {};

  return {
    icon,
    label,
    background,
    nextAmount,
  };
}

export function mapLoyaltyPrivileges (agentPrivileges: Array<AgentPrivilege> | undefined): Array<LoyaltyPrivilege> | undefined {
  if (!agentPrivileges?.length) {
    return undefined;
  }

  return agentPrivileges.map(({
    discount,
    icon,
    promoCode,
  }) => ({
    icon,
    label: promoCode?.label || discount?.label,
    promoCodeAmount: promoCode?.promoCodeAmount,
    promoCodeCount: promoCode?.promoCodeCount,
  }));
}
